/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import React from 'react';
import { Col } from 'reactstrap';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import { indiaCallingCodeId } from 'constants';
import {
  lastDateOfMonth,
  startDateOfMonth,
} from 'pages/Dashboard/components/constant';
import { GET_SELLER_COMMISSION_HISTORY } from 'pages/Vendor/VendorGraphQL';
import { currencyToLocal } from 'utils/constants';

const VendorCommission = ({ callingCodeId, vendorId }) => {
  const currency = callingCodeId === indiaCallingCodeId ? 'INR' : 'USD';
  const { data, loading, error } = useQuery(GET_SELLER_COMMISSION_HISTORY, {
    variables: {
      sellerId: parseInt(vendorId),
      fromDate: startDateOfMonth,
      toDate: lastDateOfMonth,
      currency,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.getSellerCommissionHistory) return '';

  return (
    <>
      <Col className="mb-2">
        <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
          Commission Quantity
        </span>
        <span className="f-12 text-dark-525 fw-medium d-block">
          {/* {sellerCumulativeOrderQty || 0}
          {sellerCumulativeOrderQty ? ' KG' : ''} */}
          {data?.getSellerCommissionHistory?.[0]?.totalQty || 0}{' '}
          {data?.getSellerCommissionHistory?.[0]?.qtyUnit
            ? data?.getSellerCommissionHistory?.[0]?.qtyUnit
            : currency === 'INR'
              ? 'KG'
              : 'MT'}
        </span>
      </Col>
      <Col className="mb-2">
        <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
          Commission Paid
        </span>
        <span className="f-12 text-dark-525 fw-medium d-block">
          {`${currencyToLocal(data?.getSellerCommissionHistory?.[0]?.totalAmount || 0, data?.getSellerCommissionHistory?.[0]?.rateUnit || currency)}`}

          {/* {currencyToLocal(
            sellerOrderCommissionPaid || 0,
            callingCodeId === indiaCallingCodeId ? 'INR' : 'USD',
          )} */}
        </span>
      </Col>
    </>
  );
};

export default VendorCommission;
